module.exports = __webpack_public_path__ + "static/img/3bg_14.749fdc3.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/3bg_14.png
// module id = 681
// module chunks = 1